module.exports = __webpack_public_path__ + "img/06.4ee5de1c.png";